import { render, staticRenderFns } from "./steal-freight-data-editor.vue?vue&type=template&id=59ec342e&scoped=true&"
import script from "./steal-freight-data-editor.vue?vue&type=script&lang=ts&"
export * from "./steal-freight-data-editor.vue?vue&type=script&lang=ts&"
import style0 from "./steal-freight-data-editor.vue?vue&type=style&index=0&id=59ec342e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec342e",
  null
  
)

export default component.exports